import { configureStore } from '@reduxjs/toolkit'
import preferencesReducer from "./preferencesSlice"
import formsReducer from "./formsSlice"
import joinsReducer from "./joinsSlice"
import columnsSlice from './columnsSlice'
import selectedProjectSlice from './selectedProjectSlice'
import userSlice from './userSlice'
import selectedAdminUser from './selectedAdminUser'
import selectedFormSlice from './selectedFormSlice'
import reloadDocumentsSlice from './reloadDocumentsSlice'
import filtersSlice from './filtersSlice'
import researchSlice from './researchSlice'
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers, createStore } from 'redux'
import updatePageHeaderSlice from './updatePageHeadeSlice'
import toastSlice from './toastSlice'

const rootConfig = {
    key: "root",
    storage: storage,
    blacklist: ["forms", "joins", "columns", "toast"]
};

const rootReducer = combineReducers({
    selectedProject: selectedProjectSlice,
    preferences: preferencesReducer,
    forms: formsReducer,
    joins: joinsReducer,
    columns: columnsSlice,
    user: userSlice,
    selectedAdminUser,
    selectedForm: selectedFormSlice,
    reloadDocuments: reloadDocumentsSlice,
    filters: filtersSlice,
    research: researchSlice,
    updatePageHeader: updatePageHeaderSlice,
    toast: toastSlice
})

const persisted = persistReducer(rootConfig, rootReducer);

const store = createStore(persisted);

export default store;